export default __webpack_public_path__ + "static/media/Model S.0586e7ec.png";